export class ListItem {
    id: Number;
    itemName: string;
}

export class MyException {
    status: number;
    body: any;

    constructor(status: number, body: any) {
        this.status = status;
        this.body = body;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/tag-select/multiselect.model.ts